<template>
    <div class="budgetary-legitimations" v-if="showTariff">
        <button class="float-right btn btn-outline-primary btn-sm pb-30-sm" @click="resetTariff">Restablecer</button>

        <form v-on:submit.prevent style="clear:both">
            <numeric-question v-model="amount" :min="1" currency>
                ¿Cuál es el importe?
            </numeric-question>

            <fieldset class="form-group" v-if="amount">
                <p>
                    <strong>
                        Fecha de Vencimiento
                    </strong>
                </p>
                <el-date-picker
                        v-model="expiration_day"
                        :picker-options="{firstDayOfWeek: 1}"
                        type="date"
                        @change="calculateExpiration"
                        format="dd-MM-yyyy"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="Seleccione fecha de vencimiento"
                        :clearable="false"
                        style="width: 100%;">
                </el-date-picker>
            </fieldset>

            <assertive-question
                    v-model="has_garantees"
                    v-if="expiration_higher !== null">
                ¿Tiene fiadores, garantes y/o pignorantes?
            </assertive-question>

            <assertive-question
                    v-model="company"
                    v-if="has_garantees !== null">
                ¿El titular de la póliza es una empresa?
            </assertive-question>

            <budget-summary v-if="honorary"
                            labelCost="Honorarios"
                            :cost="honorary" 
                            :retention="company"
                            service="policies">
                <slot name="callToActions"></slot>
            </budget-summary>
        </form>
    </div>
</template>

<script>
    const calculateHonorary = require('./honorary');
    export default {

        data: function () {
            return {
                showTariff: true,

                amount: null,
                expiration_day: null,
                expiration_higher: null,
                has_garantees: null,
                company: null,
            }
        },

        computed: {
            honorary() {
                return this.amount && this.expiration_higher !== null && this.has_garantees !== null && this.company !== null ? this.getHonorary() : 0
            }
        },

        methods: {
          resetTariff: function () {
            this.showTariff = false
            this.expiration_higher = null
            this.$nextTick(function () {
              this.showTariff = true
            })
          },

            getHonorary() {
                return calculateHonorary({
                    amount: this.amount,
                    expiration_higher: this.expiration_higher,
                    has_garantees: this.has_garantees,
                    company: this.company
                })
            },
            calculateExpiration() {
                const now = moment([moment().year(), moment().month(), moment().date()])
                const then = moment(this.expiration_day)
                const diff = then.diff(now, 'months')
                this.expiration_higher = diff >= 6 ? 'Si' : 'No'
            },
            getJSON() {
                return [
                    {
                        name: 'Tipo',
                        value: 'Pólizas'
                    },
                    {
                        name: '¿Cuál es el importe?',
                        value: this.amount
                    },
                    {
                        name: 'Fecha de vencimiento',
                        value: moment(this.expiration_day).format('DD/MM/YYYY')
                    },
                    {
                        name: '¿Tiene fiadores, garantes y/o pignorantes?',
                        value: this.has_garantees
                    },
                    {
                        name: '¿El titular de la póliza es una empresa?',
                        value: this.company
                    }
                ];
            }
        }
    }
</script>

<style lang="scss">
    @media (max-width: 540px) {
        .budgetary-legitimations {
            padding-bottom: 80px;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/budgetary/policies/PoliciesBudgetary.vue